import { useEffect, useState } from 'react';
import CenteredModal from '../components/widgets/modal/Modal';
import { Button } from 'react-bootstrap';

export function useCheckFrontEndVersion(intervalMs = 1 * 60 * 1000) {

    const currentVersion = window.__APP_VERSION__;
    const [outdated, setOutdated] = useState(false);

    const hardReload = () => {
        const url = new URL(window.location.href);
        url.searchParams.set('reload', Date.now());
        window.location.href = url.toString();
    }

    async function checkAppVersion() {
        if (process.env.REACT_APP_CONTEXT === 'dev') return;
        try {
            const res = await fetch(`/version.json?cb=${Date.now()}`, { cache: 'no-cache' });
            const data = await res.json();
            if (data?.version && data.version !== currentVersion) {
                setOutdated(true);
            }
        } catch (err) {
            console.error('Failed to fetch frontend version:', err);
        }
    }

    useEffect(() => {
        checkAppVersion();
        const interval = setInterval(checkAppVersion, intervalMs);
        return () => clearInterval(interval);
    }, [intervalMs]);


    function OutdatedModal() {
        return <CenteredModal
            show={outdated}
            header={<h3>Votre backoffice n'est pas à jour</h3>}
            content={<>
                <p>Il semblerait que votre navigateur n'affiche pas la dernière version du backoffice... Nous vous invitons à:</p>
                <Button variant="primary" onClick={hardReload}>Recharger la page</Button>
            </>
            }
            size='md'
            id='frontEndVersionModal'
            onHide={() => { setOutdated(false) }}
            cancel={() => { setOutdated(false) }}
        />;
    }

    return OutdatedModal;
}
